// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1Ft99","sendOtp":"AuthorizeToLogin_sendOtp__2B2L5"};